<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item active" aria-current="page" v-for="(item, index) in items" :key="index">
                <a :href="item.url" v-if="item !== last">{{ item.title }}</a>
                <span v-if="item === last">{{ item.title }} </span>
            </li>
        </ol>
    </nav>
</template>

<script>
    export default {
        props: ['items'],
        computed: {
            last() {
                return this.items.length? this.items[this.items.length - 1] : null;
            }
        }
    }
</script>

<style scoped lang="scss">
    .breadcrumb {
        background: none;
        font-size: 10px;
        padding: 0;
        margin: 0;
    }
    .breadcrumb-item + .breadcrumb-item:before {
        content: "\276F";
        font-size: 6px;
        color: #8991AE;
        transform: translate(1px, -1px);
    }
    .breadcrumb-item.active {
        color: #8991AE;
    }
</style>
